/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-prototype-builtins */

import React, { useState, useEffect, Fragment } from 'react';
import { Box, Modal, List, ListItem, ListItemText, Divider, Grid, Button, Tooltip } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { get } from 'lodash';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { getBorderColor } from '../../shared/utils';
import './split.scss';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { streamDataInformation } from '../../shared/helper';
import jsLogger from '../../logger';

const SplitInput = (props) => {
  const {
    visibleSplit,
    handleCloseSplit,
    splitDetails,
    splitObjData,
    localData_mixSplit,
    setCallExecuteFun,
    disabledStripperAndExplorerTab,
    inputOutputFlag,
    setInputOutputFlag,
    translateObject,
    openStremOverlay,
    setokbuttonFormAutoSave
  } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [streamData, setStreamData] = useState(splitObjData.reduce((obj, record) => {
    obj[`stream${record.text}`] = '';
    return obj;
  }, {}));
  const [streamValidation, setStreamValidation] = useState(splitObjData.reduce((obj, record) => {
    obj[`stream${record.text}`] = false;
    return obj;
  }, {}));
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);
  const [buttonEnable, setbutttonEnable] = useState(true);
  const [finalStreamDataarray, setfinalStreamDataarray] = useState([]);

  let collectAllFlowRate = [];

  function compareStreamData(splitObjData, mixSplit_dict_ls) {
    const splitObjData_num = splitObjData.map(item => `stream${item.text}`);
    const mixSplit_dict_ls_num = Object.keys(mixSplit_dict_ls);

    if (splitObjData_num.length !== mixSplit_dict_ls_num.length) {
      return true; // Mismatch in length
    }
    // eslint-disable-next-line
    for (const streamNum of splitObjData_num) {
      if (!mixSplit_dict_ls_num.includes(streamNum)) {
        return true; // Element from splitObjData_num not found in mixSplit_dict_ls_num
      }
    }
    // eslint-disable-next-line
    for (const streamNum of mixSplit_dict_ls_num) {
      if (!splitObjData_num.includes(streamNum)) {
        return true; // Element from mixSplit_dict_ls_num not found in splitObjData_num
      }
    }

    return false; // No mismatch found
  }

  useEffect(() => {
    if (!openStremOverlay) {  //  when calculation is not done, empty the array
      collectAllFlowRate = [];
      collectAllFlowRate.length = 0;
    }

    if (localData_mixSplit) {
      setStreamData(localData_mixSplit);
    }
  }, []);

  useEffect(() => {
    if (localData_mixSplit) {
      setStreamData(localData_mixSplit);
    }
    if (splitObjData.length !== 1) {
      const finalStreamDataArray = []; // Create an array to store the values for collecting all StreamDaata information based on stream no

      splitObjData.map(obj => {
        let stream_ouput_data = localStorage.getItem('stream_ouput_data');
        if (stream_ouput_data) {
          stream_ouput_data = JSON.parse(stream_ouput_data);
          if (stream_ouput_data && stream_ouput_data[obj.text]) { // here I should go condtion only flowsheet execute
            const finalStreamData = streamDataInformation(obj.text);
            if (finalStreamData.length) {
              finalStreamDataArray.push(finalStreamData); // Store the value in the array
            }
          }
        }
      });

      setfinalStreamDataarray(finalStreamDataArray); // Set the array as the final value
    } else {
      let stream_ouput_data = localStorage.getItem('stream_ouput_data');
      if (stream_ouput_data) {
        stream_ouput_data = JSON.parse(stream_ouput_data);
        if (stream_ouput_data && stream_ouput_data[splitObjData[0].text]) {
          const finalStreamData = streamDataInformation(splitObjData[0].text);
          if (finalStreamData.length) {
            setfinalStreamDataarray(finalStreamData);
          }
        }
      }
    }
    if (splitObjData.length === 1) {
      setStreamData({ [`stream${splitObjData[0].text}`]: Number(1.0) });
    }
    if (localStorage.getItem('mixSplit-dict')) {
      const mixSplit_dict_ls = JSON.parse(localStorage.getItem('mixSplit-dict')).mixSplit[splitDetails.id];

      if (mixSplit_dict_ls) {
        // if new stream added
        // if (splitObjData.length > Object.keys(mixSplit_dict_ls).length) {
        //   setStreamData({});
        // }

        const mismatch = compareStreamData(splitObjData, mixSplit_dict_ls);
        if (mismatch) {
          setStreamData({});
        }
      }
    }
  }, [splitObjData]);

  useEffect(() => {
    if (inputOutputFlag) { // after flowsheet executed successfully it will go inside condition
      if (localData_mixSplit) {
        setStreamData(localData_mixSplit);
      }
      if (splitObjData.length !== 1 && splitObjData.length !== 0);
      if (splitObjData.length !== 1) { // here splitObjData length more than one will go inside condition
        const finalStreamDataArray = []; // Create an array to store the values
        splitObjData.map(obj => {
          let stream_ouput_data = localStorage.getItem('stream_ouput_data');
          if (stream_ouput_data) { // this stream_ouput_data will get only flowsheet executed
            stream_ouput_data = JSON.parse(stream_ouput_data);
            if (stream_ouput_data && stream_ouput_data[obj.text]) {
              const finalStreamData = streamDataInformation(obj.text);
              // go to that streamDataInformation with stream no and get infomation about flowrate and all details
              if (finalStreamData.length) { // finalStreamData length is there than store all stream data information in array
                finalStreamDataArray.push(finalStreamData); // Store the value in the array
              }
            }
          }
          // First, parse the data from localStorage
          const mixSplitDict = JSON.parse(localStorage.getItem('mixSplit-dict'));
          // Check if mixSplitDict and mixSplit[splitDetails.id] exist or not if exist go to that condition
          if (mixSplitDict && mixSplitDict.mixSplit && mixSplitDict.mixSplit.hasOwnProperty(splitDetails.id)) {
            const newDataStream = mixSplitDict.mixSplit[splitDetails.id];
            setStreamData(newDataStream);
          }
        });
        setfinalStreamDataarray(finalStreamDataArray); // Set the array as the final value
      } else {
        // this else condition will execute when splitObjData having only one field
        let stream_ouput_data = localStorage.getItem('stream_ouput_data');
        if (stream_ouput_data) {
          stream_ouput_data = JSON.parse(stream_ouput_data);
          if (stream_ouput_data && stream_ouput_data[splitObjData[0].text]) {
            const finalStreamData = streamDataInformation(splitObjData[0].text);
            // go to that streamDataInformation with only one stream no and get infomation about flowrate and all details
            if (finalStreamData.length) {
              setfinalStreamDataarray(finalStreamData);
            }
          }
        }
      }
      if (splitObjData.length === 1) {
        setStreamData({ [`stream${splitObjData[0].text}`]: Number(1.0) });
      }
      if (localStorage.getItem('mixSplit-dict')) {
        const mixSplit_dict_ls = JSON.parse(localStorage.getItem('mixSplit-dict')).mixSplit[splitDetails.id];

        if (mixSplit_dict_ls) {
          // if new stream added
          // if (splitObjData.length > Object.keys(mixSplit_dict_ls).length) {
          //   setStreamData({});
          // }

          const mismatch = compareStreamData(splitObjData, mixSplit_dict_ls);
          if (mismatch) {
            setStreamData({});
          }
        }
      }
      setbutttonEnable(false);
    }
  }, [inputOutputFlag]);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    // This condition will pass only when saved form opened again
    if (splitObjData.length === Object.values(streamData).length) {
      if (splitObjData.length === 2) {

        const otherKey = Object.keys(streamData).find(key => key !== name);
        const otherKeyValue = Number((1 - streamData[name]).toFixed(2));

        setStreamData({ ...streamData, [otherKey]: otherKeyValue });
        jsLogger.info(`Mix-split ${name} input value changes to ${value}`);
        // console.log(`Mix-split ${name} input value changes to ${value}`);
      }
    }

    const splitObjDataArr = splitObjData.map(item => item.text);
    // validation of mixSplit by Abhishek 18-Dec
    if (Object.keys(streamData).length < splitObjData.length - 1) {
      // sum of nth -n cell
      const sumOfN_n = Object.values(streamData).reduce((sum, current) => sum + current, 0);

      if (sumOfN_n >= 1) {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Error',
          message: translateObject('Sum of Split fraction(s) is 1 or more. Please review your input'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions),
          type: 'error'
        });
      }
    }
    else
      if (Object.keys(streamData).length === splitObjData.length - 1) {
        // check sum of all cell (till n-1) : should be less then 1
        const sumOfN_1 = Object.values(streamData).reduce((sum, current) => sum + current, 0);

        if (sumOfN_1 >= 1) {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Error',
            message: translateObject('Sum of split fraction(s) is 1 or more. Please review your input'),
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions),
            type: 'error'
          });
        } else {
          const streamDataArr = Object.keys(streamData).map(item => Number(item.replace('stream', '')));
          // find the missing number
          let missingNum;
          for (let i = 0; i < splitObjDataArr.length; i += 1) {
            if (streamDataArr.includes(splitObjDataArr[i])) { // eslint-disable-next-line
              continue;
            }
            else {
              missingNum = splitObjDataArr[i];
              break;
            }
          }
          const newStreamData = { ...streamData };
          newStreamData[`stream${missingNum}`] = Number((1 - sumOfN_1).toFixed(2)); // by Abhishek for 2 decimal place after decimal
          setStreamData({ ...newStreamData });
        }

      }
  };

  const handleNumberChange = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (Number(e.target.value) < 0) {
      e.target.value = 0;
    } else if (Number(e.target.value) > 1) {
      e.target.value = 0;
    }
    const { name, value } = e.target;
    setStreamValidation({ ...streamValidation, [name]: (Number(value) > 1 || Number(value) < 0) });
    setStreamData({ ...streamData, [name]: Number(value) });
    disabledStripperAndExplorerTab();
  };

  const handleClose_Split = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    jsLogger.info('Mix-split Cancel btn clicked');
    handleCloseSplit();
  };

  const handleCloseSplitModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleClose_Split(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseSplit();
    };
  };
  const handleUpdateApply = () => {
    let id_splitMix = {};
    id_splitMix = splitDetails.id;
    const values = Object.values(streamData);
    const total = values.reduce((sumValue, item) => {
      return sumValue + Number(item);
    }, 0);

    // by Abhishek : to handle ok if there is no strem connection to product inlet
    if (Object.keys(streamData).length === 0 && splitObjData.length === 0) {
      // just close it
      handleCloseSplit();
    }
    else  // by Abhi ends here
      if (Object.keys(streamData).length !== splitObjData.length) {
        // any cell is empty
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Error',
          message: translateObject('Split fraction(s) must not be empty'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions),
          type: 'error'
        });
      }
      else { // eslint-disable-next-line
        if ((total > 1 || total < 0.9999) && (splitObjData.length !== 1)) {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Error',
            message: translateObject('Sum of split fraction(s) should be 1.0'),
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions),
            type: 'error'
          });
        } else {
          const id = id_splitMix;
          saveFormDataInLocalStorage({ record: streamData, type: 'mixSplit', id, item: 'mixSplit-dict' });
          setInputOutputFlag(false);
          setCallExecuteFun(true);
        }
      }
  };

  const getFeedName = () => {
    let splitName = '';
    const local = localStorage.getItem(splitDetails.id);
    if (local) {
      splitName = ` - ${local}`;
    } else {
      splitName = ` - Splitter ${Number(get(splitDetails, 'id', '').split('_')[1]) + 1}`;
    }
    return splitName;
  };
  // on Click OK
  const handleUpdate = () => {
    let id_splitMix = {};
    id_splitMix = splitDetails.id;
    const values = Object.values(streamData);
    const total = values.reduce((sumValue, item) => {
      return sumValue + Number(item);
    }, 0);

    // by Abhishek : to handle ok if there is no strem connection to product inlet
    if (Object.keys(streamData).length === 0 && splitObjData.length === 0) {
      // just close it
      handleCloseSplit();
    }
    else  // by Abhi ends here
      if (Object.keys(streamData).length !== splitObjData.length) {
        // any cell is empty
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Error',
          message: 'Split fraction(s) must not be empty',
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions),
          type: 'error'
        });
      }
      else { // eslint-disable-next-line
        if ((total > 1 || total < 0.9999) && (splitObjData.length !== 1)) {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Error',
            message: translateObject('Sum of split fraction(s) should be 1.0'),
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions),
            type: 'error'
          });
        } else {
          const id = id_splitMix;
          saveFormDataInLocalStorage({ record: streamData, type: 'mixSplit', id, item: 'mixSplit-dict' });
          setStreamData({});
          handleCloseSplit();
          getBorderColor(id_splitMix);
          setokbuttonFormAutoSave(true);
          jsLogger.info('Mix-split Ok btn clicked');
          if (isShowErrorMessage) {
            localStorage.setItem('globalExitBtn', 'true');
          }
        }
      }
  };
  let flowValue = null;
  // const collectAllFlowRate = [];
  if (splitObjData.length !== 1) {
    // this condition for having splitObj data having more than one input fields
    splitObjData.map(obj => {
      for (let i = 0; i < finalStreamDataarray.length; i++) {
        const streamDataInfo = finalStreamDataarray[i]; // Access the inner array collecting all stream no data here

        for (let j = 0; j < streamDataInfo.length; j++) {
          const data = streamDataInfo[j]; // Access the object within the inner array

          if (data.str === 'Stream No' && data.value === obj.text) { // here condition like data.value from array and obj.text like which mixplit slected that strem no
            for (let k = 0; k < streamDataInfo.length; k++) {
              const innerData = streamDataInfo[k]; // Access the object within the inner array

              if (innerData.str === 'Flow') {  // here need to flowrate value
                flowValue = innerData.value;
                const pushObj = { obj: obj.text, flowrate: innerData.value };
                collectAllFlowRate.push(pushObj);

                if (!openStremOverlay) {  //  when calculation is not done, empty the array
                  collectAllFlowRate = [];
                  collectAllFlowRate.length = 0;
                }

                break;
              }
            }
            break;
          }
        }
      }
    });
  } else {
    // here going only one input field splitObjData
    for (let i = 0; i < finalStreamDataarray.length; i++) {
      if (finalStreamDataarray[i].str === 'Stream No' && finalStreamDataarray[i].value === splitObjData[0].text) {
        for (let j = 0; j < finalStreamDataarray.length; j++) {
          if (finalStreamDataarray[j].str === 'Flow') {
            flowValue = finalStreamDataarray[j].value;
            if (!openStremOverlay) {  //  when calculation is not done, empty the array
              flowValue = null;
            }
            break;
          }
        }
        break;
      }
    }
  }
  let unitSet_dict = {};
  if (localStorage.getItem('system-units')) {
    // writting this condtion when user changes units the flow rate also change value based on units
    unitSet_dict = JSON.parse(localStorage.getItem('system-units'));
  }
  const flowRateUnit = unitSet_dict && unitSet_dict.flow ? unitSet_dict.flow : 'gpm';
  return (
    <Modal hideBackdrop
      open={visibleSplit}
      onClose={handleCloseSplitModal}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="mixsplitter-modal"
    >
      <Box>
        <Rnd
          default={{
            x: ((window.innerWidth / 2) - ((35 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((50 * (window.innerHeight / 100)) / 2)),
            width: '35%',
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          onResize={() => { }}
          // onResize={(e, direction, ref, delta, position) => { }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='30%'
          cancel='.no_drag,
          .mixsplitter-header-text, #drag-handle, #filled-hidden-label-small, .MuiButton-contained'
          className='mixsplitter-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='mixsplitter-grid-container'>
            <Grid item xs={12} className='mixsplitter-header-grid'>
              <div className='mixsplitter-header-text rufusBld no_drag S_heading'>{`Splitter ${getFeedName()}`}</div>
              <div className='mixsplitter-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleCloseSplitModal}
                    style={{ display: 'block' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='mixsplitter-body-container'>
              <Box sx={{ width: '100%', typography: 'body1', 'maxHeight': '67%' }} className='mixer-box-container'>
                <TabContext value='1'>
                  <TabPanel value="1" className='splitter-mixer-container'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}
                      className='col-2 list-item sansW4SeLig'>
                      <div className='rufusReg stream-number'>
                        <span className='no_drag S_Bold forground-text-primary'>{translateObject('Number of Outlet Streams')}</span>
                      </div>
                      <div className='span-3 stream-textbox'>
                        <input id='drag-handle' className='no_drag Form_Input_design'
                          type="text" value={splitObjData.length} disabled />
                      </div>
                    </div>

                    <Divider style={{ borderColor: '#D5D3E3' }} />
                    <div className='list-item sansW4SeLig'>
                      <div className='sansW6SeBld stream-numbers' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className='no_drag M_Bold forground-text-primary'>{translateObject('Stream Name')}</span>
                        <span className='no_drag M_Bold forground-text-primary'>
                          {`${translateObject('Flow Rate')} ${(flowValue != null) ? `(${flowRateUnit})` : ''}`}</span>
                        <div style={{ 'left': 'calc(100% - 88px)' }} className='span-2 no_drag M_Bold forground-text-primary'>
                          {translateObject('Split Fraction')}</div>
                      </div>
                    </div>
                    <Divider style={{ borderColor: '#D5D3E3' }} light />
                    <List component="nav" aria-label="mailbox folders" className='outlet-streams'>
                      {splitObjData.length !== 1 ? (splitObjData || []).map((obj, i) => (
                        <Fragment key={i}>
                          <ListItem className='list-item-input'>
                            <ListItemText className='col-2 sansW4SeLig'>
                              <div className='no_drag S_Bold forground-text-primary'>{translateObject('Stream')} {obj.text} <span style={{ color: 'red' }}>*</span></div>
                              <div className='S_Regular forground-text-primary'>
                                {collectAllFlowRate.length === 0 || !collectAllFlowRate.some(item => item.obj === obj.text) ? (<div className='span-3 stream-textbox'>
                                  <input id='drag-handle' className='no_drag Form_Input_design'

                                    type="text" disabled />
                                </div>) :
                                  collectAllFlowRate.map(item => {
                                    if (item.obj === obj.text) {
                                      return (<div className='span-3 stream-textbox'>
                                        <input id='drag-handle' className='no_drag Form_Input_design'

                                          type="text" value={item.flowrate} disabled />
                                      </div>);
                                    }
                                    return null;
                                  })
                                }
                              </div>
                              <div className='span-3' style={{ position: 'unset' }}>
                                <input
                                  id="filled-hidden-label-small"
                                  variant="outlined"
                                  type="number"
                                  onFocus={e => e.target.select()}
                                  name={`stream${obj.text}`}
                                  className='Form_Input_design'
                                  value={(streamData[`stream${obj.text}`] !== 'undefined') ? streamData[`stream${obj.text}`] : ''}
                                  onChange={handleNumberChange}
                                  onBlur={handleBlur}
                                  sx={{ width: 85, '& fieldset': { borderRadius: '22px' }, 'left': 'calc(100% - 85px)' }}
                                />
                                {streamValidation[`stream${obj.text}`] &&
                                  (<div style={{ 'width': '200px' }} className='error-message-text no_drag'>
                                    {translateObject('Stream Values should be between 0 and 1')}</div>)
                                }
                              </div>
                            </ListItemText>
                          </ListItem>
                          <Divider light />
                        </Fragment>
                      )) : <>

                        <ListItem className='list-item-input'>
                          <ListItemText className='col-2 sansW4SeLig' >
                            <span className='no_drag S_Bold forground-text-primary'>
                              {translateObject('Stream')} {splitObjData[0].text} <span style={{ color: 'red' }}>*</span></span>

                            <div className='S_Regular forground-text-primary'>
                              {flowValue === null ? (<div className='span-3 stream-textbox'>
                                <input id='drag-handle' className='no_drag Form_Input_design'

                                  type="text" disabled />
                              </div>) : (<div className='span-3 stream-textbox'>
                                <input id='drag-handle' className='no_drag Form_Input_design'

                                  type="text" value={flowValue} disabled />
                              </div>)}</div>

                            <div className='span-3' style={{ position: 'unset' }}>
                              <input
                                id="filled-hidden-label-small"
                                variant="outlined"
                                type="number"
                                name={`stream${splitObjData[0].text}`}
                                className='Form_Input_design'
                                value={1.0}
                                onChange={handleNumberChange}
                                onFocus={e => e.target.select()}
                                onBlur={handleBlur}
                                sx={{ width: 85, '& fieldset': { borderRadius: '22px' }, 'left': 'calc(100% - 85px)' }}
                              />
                              {streamValidation[`stream${splitObjData[0].text}`] &&
                                (<div style={{ 'width': '200px' }} className='error-message-text no_drag'>
                                  {translateObject('Stream Values should be between 0 and 1')}</div>)
                              }
                            </div>
                          </ListItemText>
                        </ListItem>
                        <Divider light />
                      </>}
                    </List>
                  </TabPanel>
                </TabContext>
              </Box>
              <Grid className='splitter-mixer-update-button' item xs={12}>
                <div className='note-item'>
                  <Grid container className='mixsplitter-note-text sansW4SeLig M_Regular'>
                    <Grid item xs={1} className='no_drag S_Bold Note'>{translateObject('Note')}</Grid>
                    {/* 1. Read the stream names from connection  <br />
                        2. Allow user to enter split fraction till second last entry and last entry will be (1-sum of all previous entries):
                        Last entry may not be last row in the table.  <br /> */}
                    <Grid item xs={10} className='no_drag S_Regular primary_text'>
                      {translateObject('Split Fraction of individual streams should be in the range of 0-1 and sum of all split fractions should be 1.')}</Grid>
                  </Grid>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={6} md={12} sm={12}>
                    <div className="mixsplitter-button">
                      <div className='apply-button'>
                        <Button variant="contained" className="sansW4SeLig M_Bold Primary_Default_Button"
                          style={{ width: '120px' }}
                          disabled={buttonEnable}
                          size="small" onClick={handleUpdateApply}>
                          {translateObject('Apply')}
                        </Button>
                      </div>
                      <div className='cancel-ok-button'>
                        <Button variant="contained" className="sansW4SeLig M_Bold Secondary-Default_button"
                          size="small" style={{ width: '120px', marginRight: '15px' }} onClick={handleCloseSplitModal}> {translateObject('Cancel')} </Button>
                        <Button variant="contained" className="sansW4SeLig M_Bold Primary_Default_Button"
                          size="small" style={{ width: '120px' }} onClick={handleUpdate}> {translateObject('OK')} </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default SplitInput;
